import classes from './Banner.module.css';

function Banner() {
	return (
		<div className={classes.bgImage}>
			<div className={classes.bigText}>
				<h2 className={classes.bigTitle + " " + classes.outline}>Hello there, I am Bogdan</h2>
				<p className={classes.bigDesc + " " + classes.outline}>Welcome to my game dev portfolio</p>
				<p className={classes.smallDesc + " " + classes.outline}>For other coding things check out my <a href="https://github.com/Zeyt8">GitHub</a></p>
			</div>
		</div>
	);
}

export default Banner;
